import './index.scss';

export default function () {
    $('#gs-add-author').click(function (e) {
        e.preventDefault();
        var len = $('.author-flag').length;
        var newInput =
            '<div class="author-flag" style="padding-left:20px; padding-top:20px;">' +
            '<label>First Name</label>' +
            '<input class="form-control" type="text" name="Authors.Authors[' + len + '].FirstName" value="">' +
            '<label>Last Name</label>' +
            '<input class="form-control" type="text" name="Authors.Authors[' + len + '].LastName" value="">' +
            '<label>Institution Ids</label>' +
            '<input class="form-control" type="text" name="Authors.Authors[' + len + '].InstitutionIds" value="">' +
            '<label>Email</label>' +
            '<input class="form-control" type="text" name="Authors.Authors[' + len + '].Email" value="">' +
            '</div>';
       $('#authors-group').append(newInput)
    });
    $('#gs-add-author-institution').click(function (e) {
        e.preventDefault();
        var len = $('.author-institution-flag').length;
        var newInput =
            '<div class="author-institution-flag" style = "padding-left:20px" >' +
            '<input class="form-control" name="Authors.Institutions[' + len + ']" />' +
            '</div>';
        $('#authors-institution-group').append(newInput)
    });

    if (!document.getElementById("gsFilterForm")) {
        return;
    }
    function refresh() {
        $('#gsFilterForm').submit();
    }
    $('#gsFilterForm .gs-reset-btn').click(function (e) {
        e.preventDefault();
        $(this).parents('.panel-body').find('select').val('');
        refresh();
    });

    $('#gsFilterForm [data-gs-order-by]').click(function (e) {
        e.preventDefault();
        let orderby = $(this).data('gsOrderBy');
        $('#gsOrderBy').val(orderby);
        refresh();
    });
    $('#gsFilterForm select').change(refresh);
    $('#gsFilterForm input[type=checkbox]').change(refresh);

    
}
